<div class="insights-container">
  <div class="row ms-2 me-2 mt-1 mb-1 ps-0 pe-0">
    <rb-loading-spinner *ngIf="dataLoading" class="spinner"></rb-loading-spinner>
    <div class="col-md-12 p-2">
      <div *ngIf="!dataLoading">
        <table class="m-table" *rbTable="loader; fixedHeaderWidth: false; columns: 2">
          <thead>
            <tr>
              <th>Battery Type</th>
              <th>
                <span rbTooltip="Accumulated amount of energy with which all the batteries in the fleet were charged." [noFix]="false">
                  Charged Energy (accumulated)
                </span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of chargedEnergyRows">
              <td>{{ row.label }}</td>
              <td>
                {{ row.chargedEnergy !== null && row.chargedEnergy !== undefined 
                    ? (row.chargedEnergy | whToMWh | removeDecimalPoints:1) + ' MWh' 
                    : 'N/A' }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <hr class="ms-2 me-2 mt-1 mb-1 ps-0 pe-0">

  <div class="row ms-2 me-2 mt-1 mb-1 ps-0 pe-0">
    <div class="col-md-4 ps-0 pe-0">
      <app-charged-energy-over-time-chart *ngIf="fleetId.length > 0" [fleetId]="fleetId" [selectedBatteryTypes]="selectedBatteryTypes"></app-charged-energy-over-time-chart>
    </div>
    <div class="col-md-4 ps-0 pe-0">
      <app-soc-delta-per-charging-procedure-chart *ngIf="fleetId.length > 0" [fleetId]="fleetId" [selectedBatteryTypes]="selectedBatteryTypes"></app-soc-delta-per-charging-procedure-chart>
    </div>
    <div class="col-md-4 ps-0 pe-0">
      <app-equivalent-full-charge-cycles-chart *ngIf="fleetId.length > 0" [fleetId]="fleetId" [selectedBatteryTypes]="selectedBatteryTypes"></app-equivalent-full-charge-cycles-chart>
    </div>
  </div>

  <hr class="ms-2 me-2 mt-1 mb-1 ps-0 pe-0">

  <div class="row ms-2 me-2 mt-1 mb-1 ps-0 pe-0">
    <div class="col-md-6 ps-0 pe-0">
      <app-soc-events-low *ngIf="fleetId.length > 0" [fleetId]="fleetId" [selectedBatteryTypes]="selectedBatteryTypes" [dataLoadingSocEvents]="dataLoadingSocEvents" [errorMessageSocEvents]="errorMessageSocEvents" [stateOfChargeEventsDatapoints]="stateOfChargeEventsDatapoints"></app-soc-events-low>
    </div>
    <div class="col-md-6 ps-0 pe-0">
      <app-soc-events-high *ngIf="fleetId.length > 0" [fleetId]="fleetId" [selectedBatteryTypes]="selectedBatteryTypes" [dataLoadingSocEvents]="dataLoadingSocEvents" [errorMessageSocEvents]="errorMessageSocEvents" [stateOfChargeEventsDatapoints]="stateOfChargeEventsDatapoints"></app-soc-events-high>
    </div>
  </div>

  <hr class="ms-2 me-2 mt-1 mb-1 ps-0 pe-0">

  <div class="row ms-2 me-2 mt-1 mb-1 ps-0 pe-0">
    <div class="col-md-6 ps-0 pe-0">
      <app-soc-start-chart *ngIf="fleetId.length > 0" [fleetId]="fleetId" [selectedBatteryTypes]="selectedBatteryTypes" [dataLoadingSoc]="dataLoadingSoc" [errorMessageSoc]="errorMessageSoc" [stateOfChargeDatapoints]="stateOfChargeDatapoints"></app-soc-start-chart>
    </div>
    <div class="col-md-6 ps-0 pe-0">
      <app-soc-end-chart *ngIf="fleetId.length > 0" [fleetId]="fleetId" [selectedBatteryTypes]="selectedBatteryTypes" [dataLoadingSoc]="dataLoadingSoc" [errorMessageSoc]="errorMessageSoc" [stateOfChargeDatapoints]="stateOfChargeDatapoints"></app-soc-end-chart>
    </div>
  </div>
</div>